// Migration V5 -> V6
// Adds support for CurveStyling.displayName (no-op on data; bump version only)

export function migrateV5ToV6(template: any): any {
  // Preserve Date objects by avoiding JSON serialization
  const cloned: any = { ...template }
  const charts = Array.isArray(template?.chartConfigs) ? template.chartConfigs : []
  cloned.chartConfigs = charts.map((cfg: any) => ({ ...cfg }))
  cloned.version = 6
  return cloned
}
